require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-calculators-how-do-taxes-and-inflation-affect-my-savings.json") })
        }
      }, "path---es-calculators-how-do-taxes-and-inflation-affect-my-savings");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-calculators-how-do-taxes-and-inflation-affect-my-savings!./.cache/json/es-calculators-how-do-taxes-and-inflation-affect-my-savings.json
// module id = 2508
// module chunks = 231608221292675